'use client'

import { usePathname, useSearchParams } from "next/navigation";
import React, { useContext, useEffect, useState } from "react";
import { pushHistory, endBackNavigation, getIsBackNavigation, historyStack, isBackDisabled, popHistory } from "@/type/historyStack"; 
import MoFloatMenuProvider, { useMoFloatMenu } from "@/context/moFloatMenuContext";
import { useHistory } from "@/context/historyContext";
import { useTranslations } from "next-intl";


export interface PageTabType {
    id: number;
    title: string;
    url?: string;
    side_url?: string;
    parentId?: number;
    sports_type_label?:string
    sports_type_name?:string
    sports_type?:number
}

interface Props<T extends PageTabType = PageTabType> {
    mainTab?: T[];
    subTab?: T[];
    thirdTab?: T[];
    clickMainTab?: (id: number, obj: T) => void;
    clickSubTab?: (id: number, obj: T) => void;
    clickThirdTab?: (id: number, obj: T) => void;
    initialSelectedTab?: number | null;
    initialSelectedSubTab?: number | null;
    initialSelectedThirdTab?: number | null;
    setLoading?:React.Dispatch<React.SetStateAction<boolean>>;
    loading?:boolean
    type?:string;
    loadFrame?:boolean;
    setLoadFrame?:React.Dispatch<React.SetStateAction<boolean>>;
    loadFrame2?:number
    setLoadFrame2?: React.Dispatch<React.SetStateAction<number>>;

    mainTabParam?:number|null
    
}

export default function pageTabType2<T extends PageTabType = PageTabType>({
    mainTab = [],
    subTab = [],
    thirdTab =[],
    clickMainTab = () => {},
    clickSubTab = () => {},
    clickThirdTab = () => {},
    initialSelectedTab = null,
    initialSelectedSubTab = null,
    initialSelectedThirdTab = null,
    setLoading,
    loading,
    type,
    loadFrame,
    setLoadFrame,
    loadFrame2,
    setLoadFrame2,
    mainTabParam,
}: Props<T>) {
    

    const [pageTab, setPageTab] = useState<T[]>([]);
    const [pageSubTab, setPageSubTab] = useState<T[]>([]);
    const [pageThirdTab, setPageThirdTab] = useState<T[]>([])

    const [selectedTab, setSelectedTab] = useState<number | null>(initialSelectedTab);
    const [selectedSubTab, setSelectedSubTab] = useState<number | null>(initialSelectedSubTab);
    const [selectedThirdTab, setSelectedThirdTab] = useState<number | null>(initialSelectedThirdTab);

    
    const [clickTab, setClickTab] = useState<boolean>(true)
    const [isFirst, setIsfirst] = useState<boolean>(true)
    const [moveTab, setMoveTab] = useState<boolean>(false)

    useEffect(() => {
        if (mainTab !== pageTab && (mainTab?.length ?? 0) !== pageTab.length) {
            setPageTab(mainTab);
        }
        if (subTab && subTab !== pageSubTab && (subTab?.length ?? 0) !== pageSubTab.length) {
            setPageSubTab(subTab);
        }
        if (thirdTab && thirdTab !== pageThirdTab && (thirdTab?.length ?? 0) !== pageThirdTab.length) {
            setPageThirdTab(thirdTab);
        }

        if (initialSelectedTab == null && mainTab && mainTab.length > 0 && selectedTab == null) {
            setSelectedTab(mainTab[0].id);
        }
        if (initialSelectedSubTab == null && subTab && subTab.length > 0 && selectedSubTab == null) {
            setSelectedSubTab(subTab[0].id);
        }
        if (initialSelectedThirdTab == null && thirdTab && thirdTab.length > 0 && selectedThirdTab == null) {
            setSelectedThirdTab(thirdTab[0].id);
        }
    }, [mainTab, 
        subTab, 
        thirdTab,
        initialSelectedTab,
        initialSelectedSubTab,
        initialSelectedThirdTab,
        pageTab.length,
        pageSubTab.length,
        pageThirdTab.length,
        selectedTab, 
        selectedSubTab,
        selectedThirdTab
    ]);

    const pathname = usePathname();
    const searchParams = useSearchParams();

    function historyPush(key:number, id: (number | null)[]) {
        // let fullPath = searchParams.toString()
        //     ? `${pathname}?${searchParams.toString()}`
        //     : pathname;
        let fullPath = pathname;

// console.log("fullPath", fullPath)
        fullPath = `tab:${fullPath}?key=${key}&id=[${id}]`;
        if (!getIsBackNavigation()) {
            pushHistory(fullPath);
        } else {
            endBackNavigation();
        }
    }

    function resetClickStatus(){
        if(setLoadFrame) setLoadFrame(false)
        setClickTab(false)
    }

    function FirstTabClick(el:any){
        setClickTab(true)
        historyPush(1, [el.id]);

        const subsForThis = pageSubTab?.filter((s) => s.parentId === el.id) ?? [];
        
        setSelectedTab(el.id);

        if (subsForThis.length > 0) {
            const firstSub = subsForThis[0];
            setSelectedSubTab(firstSub.id);

            const thirdsForThis = pageThirdTab?.filter((t) => t.parentId === firstSub.id) ?? [];
            if (thirdsForThis.length > 0) {
                const firstThird = thirdsForThis[0];
                setSelectedThirdTab(firstThird.id);
                clickThirdTab?.(firstThird.id, firstThird);
            } else {
                clickSubTab?.(firstSub.id, firstSub);
            }
        }

        clickMainTab?.(el.id, el);
        const subTab = document.querySelector('.liveScoreSubTab');
      if (subTab) {
  setTimeout(() => {
    subTab.scrollTop = 0;
  subTab.scrollLeft = 0;
  }, 0);
}

        
    }

    function SecondTabClick(el:any){
                                            
        setClickTab(true)
        historyPush(1, [selectedTab, el.id]);

        const thirdsForThis = pageThirdTab?.filter((t) => t.parentId === el.id) ?? [];
        setSelectedSubTab(el.id);
        if (thirdsForThis.length > 0) {
            const firstThird = thirdsForThis[0];
            setSelectedThirdTab(firstThird.id);
            clickThirdTab?.(firstThird.id, firstThird);
        } 
        clickSubTab?.(el.id, el);
        
    }

    function ThirdTabClick(el:any){
        if (setLoading) setLoading(true);

        setClickTab(true)
        historyPush(1, [selectedTab, selectedSubTab, el.id]);

        setSelectedThirdTab(el.id);
        clickThirdTab(el.id, el);
    }

    const { historyTab, SetHistoryTab } = useHistory()
    useEffect(()=>{
        if (loadFrame2 === 0) return; 
        if (clickTab || isFirst) {
            setIsfirst(false);
            resetClickStatus();
            return;
        }
        if (getIsBackNavigation()) {
            endBackNavigation();
        } else {
            pushHistory("just back");
        }
        resetClickStatus();
    },[ loadFrame2 ])

    useEffect(()=>{
        if(mainTabParam){
            // FirstTabClick(pageTab[mainTabParam])
        }

        
    },[ mainTabParam ])
    

    
    // 탭리스트 세팅되면 각 첫 항목 선택
    // 뒤로가기 접근 시 전달된 값에따라 세팅
    useEffect(() => {
        if (pageTab.length > 0) {
            setClickTab(true)



            // 기본값 (첫 번째 탭들)
            const firstMain = pageTab[0];
            const subs = pageSubTab.filter(s => s.parentId === firstMain.id);
            const firstSub = subs[0];
            const thirds = firstSub ? pageThirdTab.filter(t => t.parentId === firstSub.id) : [];
            const firstThird = thirds[0];

            if (historyTab.length > 0) {
                setMoveTab(true)
                const main = pageTab.find(el => el.id === historyTab[0]) ?? firstMain;

                const subCandidates = pageSubTab.filter(el => el.parentId === main.id);
                const sub = historyTab[1]
                    ? pageSubTab.find(el => el.id === historyTab[1])
                    : subCandidates[0];

                const thirdCandidates = sub ? pageThirdTab.filter(el => el.parentId === sub.id) : [];
                const third = historyTab[2]
                    ? pageThirdTab.find(el => el.id === historyTab[2])
                    : thirdCandidates[0];

                if (third) {
                    setSelectedTab(main.id);
                    if(sub) setSelectedSubTab(sub.id);
                    setSelectedThirdTab(third.id);
                    clickThirdTab(third.id, third);
                } else if (sub) {
                    setSelectedTab(main.id);
                    setSelectedSubTab(sub.id);
                    clickSubTab(sub.id, sub);
                } else if (main) {
                    setSelectedTab(main.id);
                    clickMainTab(main.id, main);
                }
                SetHistoryTab([])

            } else {
                if(moveTab){
                    setMoveTab(false)
                    return;
                }
                // 처음 진입 시
                if (!type) popHistory();

                if (firstThird) {
                    clickThirdTab(firstThird.id, firstThird);
                    if (!type) historyPush(3, [firstMain.id, firstSub.id, firstThird.id]);
                } else if (firstSub) {
                    clickSubTab(firstSub.id, firstSub);
                    if (!type) historyPush(2, [firstMain.id, firstSub.id]);
                } else {
                    clickMainTab(firstMain.id, firstMain);
                    if (!type) historyPush(1, [firstMain.id]);
                }
            }
        }
    }, [pageTab, pageSubTab, pageThirdTab, JSON.stringify(historyTab)]);

    useEffect(() => {
        if (!pageTab.length || !mainTabParam) return;
        const targetMain = pageTab.find(el => el.id === mainTabParam);
        if (targetMain) {
            setSelectedTab(targetMain.id);

            const subs = pageSubTab.filter(s => s.parentId === targetMain.id);
            const firstSub = subs[0];
            if (firstSub) {
            setSelectedSubTab(firstSub.id);

            const thirds = pageThirdTab.filter(t => t.parentId === firstSub.id);
            const firstThird = thirds[0];
            if (firstThird) {
                setSelectedThirdTab(firstThird.id);
                clickThirdTab?.(firstThird.id, firstThird);
            } else {
                clickSubTab?.(firstSub.id, firstSub);
            }
            } else {
            clickMainTab?.(targetMain.id, targetMain);
            }
        }
    }, [mainTabParam, pageTab, pageSubTab, pageThirdTab]);

    const t = useTranslations('Sports')
 
    return (
        <>

        {/* 메인 에서만 */}
        {type ?
            (
            <div className="global-top-game-container">
                <header className={`${pageSubTab.length == 0 ? "m-b-8" : ""}`}>
                    <div className="tabs">
                       
                        {pageTab &&
                            pageTab.map((el, idx) => (
                                <div key={el.id}
                                    onClick={() => { FirstTabClick(el) }}
                                    style={{
                                        width: `${pageTab.length > 0 && pageTab.length <= 4 ? `${100 / pageTab.length}%` : "fit-content"}`,
                                    }}>
                                    <button className={selectedTab === el.id ? "active" : ""}
                                            style={{ width: `${pageTab.length <= 4 ? `96%` : "fit-content"}` }}>
                                                
                                        <i className={`--i sports ${el.sports_type_label}`}></i>
                                        {t(el.title)}
                                    </button>
                                </div>
                            ))
                        }
                    </div>
                </header>
                {pageSubTab.length > 0 &&
                <header className="league-tabs-header">
                    <div className="league-tabs">
                        {pageSubTab
                            .filter((sub) => sub.parentId === selectedTab)
                            .map((el) => (
                                <div key={el.id}
                                    onClick={() => { SecondTabClick(el) }}>
                                    <button className={selectedSubTab === el.id ? "active" : ""}>
                                        {t(el.title)}
                                        {/* {el.url} */}
                                    </button>
                                </div>
                            ))}
                    </div>
                </header>
                }
            </div>
            ) :
            (
            <div className={`liveScoreWrapper`}>
                <div className={`liveScoreInner  p-t-4`}>
                    <div className={`liveScoreTab tab m-b-5 p-l-3 p-r-3`}>
                        {pageTab &&
                            pageTab.map((el, idx) => (
                                <div key={el.id}
                                    onClick={() => {FirstTabClick(el) }}
                                    style={{
                                        width: `${pageTab.length > 0 && pageTab.length <= 4 ? `${100 / pageTab.length}%` : "fit-content"}`,
                                    }}>
                                    <button className={selectedTab === el.id ? "active" : ""}
                                            style={{ width: `${pageTab.length <= 4 ? `96%` : "fit-content"}` }}>
                                        {t(el.title)}
                                    </button>
                                </div>
                            ))}
                    </div>

                    {pageSubTab &&
                        <div className={`liveScoreSubTab tab`}>
                            {pageSubTab
                                .filter((sub) => sub.parentId === selectedTab)
                                .map((el) => (
                                    <div key={el.id}
                                        onClick={() => {SecondTabClick(el) }}
                                        className={`${pageSubTab.length >= 4 ? 'w22' : ''}`}
                                        // style={{ 
                                        //     width: `${pageSubTab.length <= 4 ? `calc(100% / 4.5)` : "fit-content"}` ,
                                        //     minWidth: `${pageSubTab.length <= 4 ? `calc(100% / 4.5)` : "fit-content"}` 
                                        // }}
                                        >
                                        <button className={selectedSubTab === el.id ? "active" : ""}>
                                            {t(el.title)}
                                            {/* {el.url} */}
                                        </button>
                                    </div>
                                ))}
                        </div>
                    }
                    {pageThirdTab &&
                        <div className={`liveScoreSubTab tab m-t-5`}>
                            {pageThirdTab
                                .filter((sub) => sub.parentId === selectedSubTab)
                                .map((el) => (
                                    <div key={el.id}
                                        onClick={() => { ThirdTabClick(el) }}
                                        style={{ width: `${100 / pageThirdTab.filter((sub) => sub.parentId === selectedSubTab).length}%` }}>
                                        <button className={selectedThirdTab === el.id ? "active" : ""}
                                                style={{ width: `100%` }}>
                                            {t(el.title)}
                                            {/* {el.url} */}
                                        </button>
                                    </div>
                                ))}
                        </div>
                    }
                </div>

            </div>
            )
        }
        </>
    );
}
